
const MapStateUtils = {

    apply(item, props) {
        if (item.lat && item.lon) {
            const center = [item.lat, item.lon];
            props.panTo(center);
        }
        if (item.zoom) {
            props.changeZoomLevel(item.zoom);
        }
        if (item.layers) {
            const self = this;
            item.layers.forEach(layer => {
                const result = self.findLayer(props, layer.layerid, props.layers, 0, []);
                if (result !== false) {
                    self.setProperties(props, layer, result);
                }
            });
        }
    },

    findLayer(props, layerId, layers, level, path) {
        for (let i = 0; i < layers.length; i++) {
            const l = layers[i];
            if (l.id == layerId) {
                let subPath = [];
                if (level > 0) {
                    subPath = [...path, i];
                }
                // qwc2 addresses the top level layer by its id (older versions used a uuid)
                return {
                    layerId: l.id,
                    path: subPath
                };
            } else {
                if (l.sublayers && l.sublayers.length) {
                    let subPath = [];
                    if (level > 0) {
                        subPath = [...path, i];
                    }
                    const subRes = this.findLayer(props, layerId, l.sublayers, level + 1, subPath);
                    if (subRes !== false) {
                        subRes.layerId = l.id;
                        return subRes;
                    }
                }
            }
        }
        return false;
    },

    setProperties(props, properties, res) {
        if (typeof properties.visibility !== 'undefined') {
            props.changeLayerProperty(res.layerId, 'visibility', properties.visibility, res.path);
        }
        if (typeof properties.opacity !== 'undefined') {
            //this.props.changeLayerProperty(res.uuid, 'opacity', Math.max(1, 255 - properties.opacity), res.path);
            props.changeLayerProperty(res.layerId, 'opacity', properties.opacity, res.path);
        }
    },

};

export default MapStateUtils;
